import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import SectionView from "../../../layout/section/SectionView";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import {BillOfMaterialsPreviewItemOfMaterial} from "../../../../model/job/BillOfMaterialsPreviewItems";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import {OnFailure, OnSuccessData} from "../../../../store/action/actionHelpers";
import {removeMaterialFromAssetOnBillOfMaterials} from "../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import SuggestedAssetPrice from "../../../../model/job/SuggestedAssetPrice";
import {BomItem} from "../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On successfully removed material callback.
	 */
	onSuccess: (suggestedAssetSellPrice: SuggestedAssetPrice) => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Bill of materials id
	 */
	bomDetailsId: string;
	/**
	 * Asset selected to remove.
	 */
	selectedAsset: BomItem;
	/**
	 * Asset selected to remove.
	 */
	selectedMaterial: BillOfMaterialsPreviewItemOfMaterial;
	/**
	 * Job id
	 */
	jobId: string;
}

interface DispatchProps {
	/**
	 */
	removeMaterialFromAssetOnBillOfMaterials: (bomId: string, assetId: string, materialId: string, jobId: string,
		onSuccess: OnSuccessData<SuggestedAssetPrice>, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & DispatchProps;

class RemoveMaterialModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isSubmitting: false
		};
		this.removeMaterial = this.removeMaterial.bind(this);
		this.getHeader = this.getHeader.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={this.getHeader()}>
				<SectionView>
					This material will be removed from the asset: "<strong>{this.props.selectedAsset.name}</strong>"
				</SectionView>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.state.isSubmitting}/>
					<ButtonPrimary onClick={this.removeMaterial}
								   label={"Remove"}
								   disabled={this.state.isSubmitting}
								   isLoading={this.state.isSubmitting}/>
				</FormButtonsView>
			</Modal>
		);
	}

	getHeader() {
		return (
			<div>Remove "<strong>{this.props.selectedMaterial.description}</strong>"?</div>
		);
	}

	removeMaterial() {
		this.setState({isSubmitting: true}, () => {
			this.props.removeMaterialFromAssetOnBillOfMaterials(this.props.bomDetailsId,
				this.props.selectedAsset.id, this.props.selectedMaterial.id.getOrElse(''),
				this.props.jobId,
				(price) => {
					this.setState({isSubmitting: false});
					this.props.onSuccess(price);
					Toast.success('Material removed', 'Remove material');
				},
				(error) => {
					this.setState({isSubmitting: false});
					notifyBugsnagAndShowToast(error, 'Remove material from asset on order');
				});
		});

	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		removeMaterialFromAssetOnBillOfMaterials: (bomId: string, assetId: string, materialId: string, jobId: string,
			onSuccess: OnSuccessData<SuggestedAssetPrice>, onFailure: OnFailure) => dispatch(
			removeMaterialFromAssetOnBillOfMaterials(bomId, assetId, materialId, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(RemoveMaterialModal);